/**
 * The interface icons — one small set, one stroke weight, drawn by hand.
 *
 * These are not the crayon art in `Art.jsx`. That is decorative and ships
 * as raster drawings; this is chrome, and chrome has to be crisp at 24px,
 * follow `currentColor` so it themes for free, and sit on the same 1.6px
 * stroke as the pencil icon the quick-log already uses. No icon library:
 * seven glyphs do not justify a dependency, and a hand-drawn set stays
 * consistent because there is only one hand.
 *
 * Every icon is `aria-hidden`. A tab, a row, a back link — each carries a
 * visible text label, so the glyph is never the only carrier of a fact
 * (nav-label-icon). Pass `size` in px; the default is the tab-bar size.
 */

function Icon({ size = 24, children }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export function HomeIcon(props) {
  return (
    <Icon {...props}>
      <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4.5v-6h-5v6H5a1 1 0 0 1-1-1v-9.5Z" />
    </Icon>
  );
}

export function BankIcon(props) {
  return (
    <Icon {...props}>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M3 11h18M7 4.5h10" />
      <circle cx="16.5" cy="15.5" r="1" fill="currentColor" stroke="none" />
    </Icon>
  );
}

export function StarIcon(props) {
  return (
    <Icon {...props}>
      <path d="m12 3.5 2.6 5.4 5.9.8-4.3 4.1 1.1 5.9L12 16.9l-5.3 2.8 1.1-5.9-4.3-4.1 5.9-.8L12 3.5Z" />
    </Icon>
  );
}

export function FamilyIcon(props) {
  return (
    <Icon {...props}>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.5 20v-1.5a5.5 5.5 0 0 1 11 0V20" />
      <circle cx="17" cy="9.5" r="2.4" />
      <path d="M16 15.2a4 4 0 0 1 4.5 4V20" />
    </Icon>
  );
}

export function SwitchIcon(props) {
  return (
    <Icon {...props}>
      <path d="M4 8h13l-3-3M20 16H7l3 3" />
    </Icon>
  );
}

export function ChevronLeftIcon(props) {
  return (
    <Icon {...props}>
      <path d="m14.5 6-6 6 6 6" />
    </Icon>
  );
}

export function ChevronRightIcon(props) {
  return (
    <Icon {...props}>
      <path d="m9.5 6 6 6-6 6" />
    </Icon>
  );
}
